module.exports = "<div id=\"video-popup\" class=\"generic-player lightbox lightbox-frame\">\n  <div class=\"heading\">\n    <h3><%= title %></h3>\n  </div>\n  <div class=\"video-player-wrapper\">\n    <div id=\"ec-player\"></div>\n    <div id='ec-loading'><%= i18n.loadingDDD %></div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./js/common/templates/media/ECVideoPopup.html
// module id = 1076
// module chunks = 26 27 28